import {
  Directive,
  inject,
  OnDestroy,
  OnInit,
  ViewContainerRef,
} from '@angular/core';
import { PortalService } from '@core/services/portal.service';

@Directive({
  selector: '[appPortalHost]',
  standalone: true,
})
export class PortalHostDirective implements OnInit, OnDestroy {
  private _portal = inject(PortalService);

  constructor(public viewContainerRef: ViewContainerRef) {}

  ngOnInit(): void {
    this._portal.registerHost(this);
  }

  ngOnDestroy(): void {
    this._portal.clearHost(this);
  }
}